module.exports = __webpack_public_path__ + "img/pro-manage4.68f898ef.png";